module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delete-account"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status != 'none'),
      expression: "status != 'none'"
    }]
  }, [(_vm.step === 1) ? _c('div', {
    staticClass: "step-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('1')))]), _vm._v(" "), _c('div', {
    staticClass: "delete-flex delete-head"
  }, [_c('div', {
    staticClass: "delete-name"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/dashboard/avatar_2x.png",
      "alt": "header img"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vip",
    class: [_vm.isDueTo ? 'yes' : 'no']
  }), _vm._v(" "), _c('div', {
    staticClass: "delete-name-text"
  }, [_vm._v(_vm._s(_vm.user.nickname))])]), _vm._v(" "), (_vm.user.max_device_count) ? _c('div', {
    staticClass: "delete-date-text",
    class: [_vm.isDueTo ? 'yes' : 'no'],
    domProps: {
      "innerHTML": _vm._s(_vm.isUserData ? (_vm.isDueTo ? _vm.$t('3') : _vm.$t('2')) : '&nbsp;')
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "delete-flex"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('4')))]), _vm._v(" "), (_vm.currentLang === 'en') ? _c('div', [_vm._v(_vm._s(_vm.user.max_device_count) + _vm._s(_vm.user.max_device_count > 1 ? _vm.$t('5') : _vm.$t('one_5')))]) : _c('div', [_vm._v(_vm._s(_vm.user.max_device_count) + _vm._s(_vm.$t('5')))])]), _vm._v(" "), _c('div', {
    staticClass: "delete-flex delete-date"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('6')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.isUserData ? _vm.date : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "delete-btn",
    class: {
      'disabled': !_vm.isUserData
    },
    on: {
      "click": function($event) {
        return _vm.handClick(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('7')))])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "step-2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('8')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "delete-input",
    attrs: {
      "type": "password",
      "maxlength": "50",
      "placeholder": _vm.$t('9')
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "delete-btn",
    class: {
      'disabled': !_vm.isUserData || _vm.pwd.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.handClick(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('10')))])]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "step-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('1')))]), _vm._v(" "), _c('div', {
    staticClass: "delete-status"
  }, [_vm._v(_vm._s(_vm.$t('11')))]), _vm._v(" "), _c('div', {
    staticClass: "delete-status-msg"
  }, [_vm._v(_vm._s(_vm.$t('12')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "delete-btn",
    class: {
      'disabled': _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handClick('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('13')))])]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('div', {
    staticClass: "step-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('1')))]), _vm._v(" "), _c('div', {
    staticClass: "delete-status"
  }, [_vm._v(_vm._s(_vm.$t('14')))]), _vm._v(" "), _c('div', {
    staticClass: "delete-status-msg"
  }, [_vm._v(_vm._s(_vm.$t('15')))]), _vm._v(" "), _c('div', {
    staticClass: "delete-btn",
    on: {
      "click": function($event) {
        return _vm.handClick(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('16')))])]) : _vm._e(), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  })], 1), _vm._v(" "), (_vm.popup) ? _c('div', {
    staticClass: "delete-popup",
    on: {
      "click": function($event) {
        _vm.disabled ? '' : _vm.popup = false
      }
    }
  }, [_c('div', {
    staticClass: "popup",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_vm._v(_vm._s(_vm.$t('18')))]), _vm._v(" "), _c('div', {
    staticClass: "popup-msg"
  }, [_vm._v(_vm._s(_vm.$t('19')))]), _vm._v(" "), _c('div', {
    staticClass: "popup-btn",
    class: {
      'disabled': _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.disabled ? '' : _vm.popup = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('21')))]), _vm._v(" "), _c('div', {
    staticClass: "popup-btn-text",
    class: {
      'disabled': _vm.disabled
    },
    on: {
      "click": _vm.handCancellation
    }
  }, [_vm._v(_vm._s(_vm.$t('20')))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20e14c7f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/deleteAccount/index.vue
// module id = 1275
// module chunks = 1